import {AuthService} from '@/core/service/auth.service'
import {roomService} from '@/core/service/room.service'
import {RoomEventApi, roomEventApi} from '@/core/api/room.event.api'
import {BaseApi} from '@/core/api/base.api'
import _ from 'lodash'
import {RoomInfo} from "@/core/api/room.info.api";
import {groupApi} from "@/core/api/group.api";
import {Device} from "@/utils";
import {grmRoomWebPubsubClient} from "@/core/GrmRoomWebPubsubClient";

class RoomApi extends BaseApi {
    #client
    #roomData
    #event
    #ready = false

    #serverTime = {
        time: Date.now(),
        diff: 0
    }

    #joinTime
    #leaved
    #leaveReason
    #camStudyType = ['camstudy', 'cam_study', 'camstudy_m']

    constructor() {
        super()
        this.#client = grmRoomWebPubsubClient;
        this.#roomData = {}
        // room api 를 바라보는(ex: ui) 이벤트 객체
        this.#event = new RoomEventApi() //.runEvent();

        this.RoomInfo = RoomInfo;
        this.Group = groupApi;
    }

    #Events = {
        room_reconnected: function(e){
            this.trigger(e)
        },
        room_disconnected: function(e){
            this.trigger(e)
        },
        room_changeRoomMode: function (e) {
            this.#roomData.room.prevRoomMode = this.#roomData.room.roomMode;
            this.#roomData.room.roomMode = e.data.roomMode;
            e.data = {...e.data, prevRoomMode: this.#roomData.room.prevRoomMode}
            this.emit(e)
        },
        room_changeRoomTitle: function (e) {
            this.#roomData.room.roomTitle = e.data.roomTitle;
            this.emit({type: 'room_changeRoomTitle', data: e.data})
        },
        room_changeDefinePasswd: function (e) {
            this.#roomData.room.definePasswd = e.data.definePasswd;
            this.#roomData.room.passwd = e.data.passwd;
            this.emit({type: 'room_changeDefinePasswd', data: e.data})
        },
        room_changeRoomInfo: function (e) {
            this.#roomData.room.roomTitle = e.data.roomTitle;
            this.#roomData.room.definePasswd = e.data.definePasswd;
            this.#roomData.room.passwd = e.data.passwd;
            this.#roomData.room.beginDate = e.data.beginDate
            this.#roomData.room.endResvDate = e.data.endResvDate
            this.emit({type: 'room_changeRoomInfo', data: e.data})
        },
        room_end: function (e) {
            this.emit(e)
        },
    }

    getCurrentDateTime() {
        return Date.now() + this.#serverTime.diff;
    }
    getEnterServerTime() {
        return this.#serverTime.time;
    }
    getJoinTime() {
        return this.#joinTime;
    }

    async getRoom({roomId, roomUrlId}) {
        return await roomService.getRoom({roomId, roomUrlId})
    }
    async checkRoom({roomId, roomUrlId}) {
        return await roomService.checkRoom({roomId, roomUrlId})
    }
    async createRoom(room) {
        return await roomService.createRoom(room)
    }
    async enter({enterParams, deviceSettings}) {
        let {roomId, roomUrlId} = enterParams
        if (!roomId && !roomUrlId) {
            throw 'invalid enterParams'
        }
        if (!roomId && roomUrlId) {
            let {data} = await roomService.getRoom({roomUrlId})
            roomId = enterParams.roomId = data.roomId
        }

        const {data} = await AuthService.requestEnter(roomId, enterParams);

        // server time
        (() => {
            this.#serverTime.time = data.serverTime || Date.now();
            this.#serverTime.timeDiff = Date.now() - new Date(data.serverTime);
            this.#joinTime = Date.now();
        })();

        Object.assign(data, {
            roomId,
            oncomplete: async () => {
                this._eventListen(this.#Events, this);

                try {
                    await roomService.enter({
                        roomId,
                        tokenId: data.roomToken.tokenId
                    })
                } catch (e) {
                    if (e.message && e.message.includes('NOT_AUTHORIZED_USER')) {
                        Room.trigger({
                            type: 'room_enter_failed',
                            data: {
                                reason: 'NOT_AUTHORIZED_USER'
                            }
                        })
                    }
                    return;
                }

                // 방 기본 정보 조회
                let roomData = await roomService.getRoom({roomId})
                Object.assign(this.#roomData, {
                    room: roomData.data,
                    roomId: roomData.data.roomId,
                    me: data.roomUser,
                    roomOptions: {} // TODO
                })

                {
                    // get Group
                    await groupApi.setGroupInfo(roomData.data.groupId)
                }
                if (deviceSettings) {
                    Room.Call.Stream.setLocalDeviceSetting(deviceSettings)
                }

                await roomEventApi.trigger('roomDataInit', {client: this})

                await Room.User.init();
                this.#ready = true
                await roomEventApi.trigger('roomClientReady', {client: this})

                roomEventApi.runEvent();

                // trigger ui event
                (() => {
                    let data = _.cloneDeep(this.#roomData)
                    this.emit({
                        // this.#event.trigger({
                        type: 'room_data_init',
                        data
                    })
                })()
                this.#event.runEvent();

                // visibility
                (() => {
                    if(!Device.isMobile() && !Device.isTablet()){
                        return;
                    }
                    document.addEventListener('visibilitychange',  e => {
                        if(document.hidden){
                            Room.trigger('room_core_visibilitychange', {hidden: true});
                            return;
                        }
                        if(Room.isLeaved()){
                            return;
                        }
                        Room.trigger('room_core_visibilitychange', {hidden: false});
                    });
                })();
            }
        });

        await this.getClient().connect(data);
        await data.oncomplete();
    }

    async reqLeave (reason='normal') {
        if(!this.#joinTime){
            return;
        }
        if(this.isLeaved()){
            return;
        }
        await roomService.leave({reason});
        await this.leaved({reason});
    }

    async leaved ({reason}) {
        if(this.#leaved){
            console.log('leave already');
            return;
        }
        try{
            this.#leaved = true;
            this.#leaveReason = reason;
        }finally{
            const event = {
                type: 'room_leaved',
                data: {
                    reason
                }
            };
            Room.emit(event);
            roomEventApi.trigger(event);
        }

    }

    isEntered () {
        if(this.isLeaved()) return false;
        return !!this.getJoinTime();
    }
    isLeaved () {
        return this.#leaved;
    }

    isCamStudy () {
        return this.#camStudyType.includes(this.#roomData.room.roomType);
    }

    async changeRoomTitle(roomTitle) {
        return roomService.changeRoomTitle(roomTitle)
    }
    async changeDefinePasswd(data) {
        return roomService.changeDefinePasswd(data)
    }

    addEventListener(type, listener, options) {
        this.#event.addEventListener(type, listener, options)
        return this
    }

    removeEventListener(type, listener) {
        this.#event.removeEventListener(type, listener)
        return this
    }

    addEventListeners(listeners, instance = this) {
        this.#event.addEventListeners(listeners, instance)
    }

    removeEventListeners(listeners) {
        this.#event.removeEventListeners(listeners)
    }

    pauseEvent() {
        this.#event.pauseEvent()
    }

    emit(e) {
        this.#event.pushEvent.apply(this.#event, arguments)
    }

    async trigger(e) {
        return await this.#event.trigger.apply(this.#event, arguments)
    }

    getClient() {
        return this.#client
    }

    // callback 에서 async 가 필요하면 async 로 생성하거나 promise 를 꼭 리턴 해 준다.
    ready(callback, options) {
        if (!this.#ready) {
            roomEventApi.addEventListener('roomClientReady', callback, {
                once: true,
                ...options
            })
            return
        }
        callback({client: this})
    }

    getRoomData() {
        return this.#roomData
    }

    addRoomData(data) {
        if (data) {
            Object.assign(this.#roomData, data)
        }
        return this
    }

    changeRoomData(data) {
        this.#roomData.room.defaultCameraStatus = data.defaultCameraStatus;
        this.#roomData.room.defaultMicStatus = data.defaultMicStatus
        if (data.endResvDate) {
            this.#roomData.room.endResvDate = data.endResvDate
        }
        if (data.useVacancyDetection !== undefined) {
            this.#roomData.roomCamStudy.camStudy.useVacancyDetection = data.useVacancyDetection
        }
        if(data.vacancyDetectMinutes !== undefined){
            this.#roomData.roomCamStudy.camStudy.vacancyDetectMinutes = data.vacancyDetectMinutes
        }
        if(data.useDefinePasswd !== undefined) {
            this.#roomData.room.definePasswd = data.useDefinePasswd
        }
        if(data.passwd !== undefined) {
            this.#roomData.room.passwd = data.passwd
        }
    }

    async changeRoomMode(roomMode) {
        await roomService.changeRoomMode(roomMode)
    }

    isEduCallMode() {
        switch (this.getRoomData().roomType) {
            case 'edu':
            case 'grmlms':
                return true
        }
        return false
    }

    isLms() {
        return this.isRoomType('grmlms');
    }

    isRoomType(roomType) {
        return this.getRoomData().roomType === roomType;
    }

    isRoomGroupMode() {
        return this.getRoomData().room && this.getRoomData().room.roomMode == 'group';
    }
}

export const Room = new RoomApi()
